import React from "react";
import AppShell from "../components/layout/AppShell";
import { Card } from "../components/common/UIKit";

export default function IntegrationsPage() {
  return (
    <AppShell title="Integrations" subtitle="Connect your favorite tools and services.">
      <div className="flex items-center justify-center min-h-[calc(100vh-200px)]">
        <div className="text-center">
      
          <h3 className="text-lg font-semibold text-zinc-900 mb-2">Coming Soon</h3>
         
        </div>
      </div>
    </AppShell>
  );
}